import {
  FIELD_OWNERSHIP_OWNER,
  FIELD_OWNERSHIP_OWNER_LABEL_KEY,
  FIELD_OWNERSHIP_PRECEDENCE_LABEL_KEY,
  OWNERSHIP_ENTITY_ALL,
} from './IntegrationsDataSources.constants'
import { getMockFieldOwnershipEntities } from './IntegrationsDataSources.mocks'

function getIsFieldOwnerImport(owner) {
  return owner === FIELD_OWNERSHIP_OWNER.import
}

export function getOwnershipEntityOptions(t) {
  return [
    {
      label: t('RentalPortal.IntegrationsOwnershipEntityAllKey'),
      value: OWNERSHIP_ENTITY_ALL,
    },
    ...getMockFieldOwnershipEntities().map(entity => ({
      label: entity,
      value: entity,
    })),
  ]
}

export function getIsIntegrationsSourceEmpty({ hasError, isLoading, policy }) {
  return !isLoading && !hasError && !policy
}

export function getOwnershipRowKey(item) {
  return `${item.entity}.${item.field}`
}

export function getOwnershipOwnerText({ item, t }) {
  return getIsFieldOwnerImport(item.owner)
    ? item.source_label
    : t(FIELD_OWNERSHIP_OWNER_LABEL_KEY[item.owner])
}

export function getOwnershipPrecedenceOptions(t) {
  return Object.entries(FIELD_OWNERSHIP_PRECEDENCE_LABEL_KEY).map(
    ([precedence, labelKey]) => ({ label: t(labelKey), value: precedence })
  )
}

export function getOwnershipOption({ options, value }) {
  return options.find(option => option.value === value) ?? null
}

export function getIsFieldOwnerPortal(owner) {
  return owner === FIELD_OWNERSHIP_OWNER.portal
}
